import { Component, Input, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { NavigationEnd, Router } from '@angular/router';
import { AppFacade } from '@app/app.facade';
import { DestroyableDirective } from '@app/shared/directives/destroyable';
import { AuthenticationSandbox, ConfigService, Culture } from '@hohr/config';
import { PopoverController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { filter, takeUntil } from 'rxjs/operators';
import { MenuComponent } from './menu/menu.component';
import { Observable } from 'rxjs';
import { MyCvFeatureFlags } from '@app/features/my-cvs/data-structures/my-cvs-feature-flags.interface';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent extends DestroyableDirective implements OnInit {
  @Input() isAuthenticated = false;
  @Input() profilePhoto: Blob;
  @Input() username: string;
  @Input() myprofileURI: string;

  languageControl = new FormControl();
  displayCreateCvButton = true;
  cultures: Culture[] = this.appFacade.cultures;

  constructor(
    public router: Router,
    public authSandbox: AuthenticationSandbox,
    public appFacade: AppFacade,
    private popoverController: PopoverController,
    private translateService: TranslateService,
    public configService: ConfigService
  ) {
    super();
    this.subscribeRouterEvents();
  }

  private myCvFeatureFlags = MyCvFeatureFlags;
  myCvFeaturedFlags$: Observable<boolean>;

  ngOnInit(): void {
    const culture = this.appFacade.getCultureByCultureCode(
      this.translateService.currentLang
    );
    this.appFacade.setCurrentCulture(culture);
    this.languageControl.patchValue(culture);

    if (this.configService.config) {
      this.myCvFeaturedFlags$ = this.configService.checkFeatureFlag(
        this.myCvFeatureFlags.MyCvHasCreateModule
      );
    }
  }

  subscribeRouterEvents = () => {
    this.router.events
      .pipe(
        takeUntil(this.destroyed$),
        filter((e) => e instanceof NavigationEnd)
      )
      .subscribe((route: NavigationEnd) => {
        if (route.url.includes('/create')) {
          return (this.displayCreateCvButton = false);
        }

        this.displayCreateCvButton = true;
      });
  };

  onLogoutClicked() {
    this.authSandbox.logout();
    this.router.navigate(['']);
  }

  changeLanguage(culture: Culture) {
    this.appFacade.setCurrentCulture(culture);
  }

  async showMenu(ev: Event) {
    const popover = await this.popoverController.create({
      component: MenuComponent,
      event: ev,
      showBackdrop: false,
      componentProps: {
        authenticated: this.isAuthenticated,
        username: this.username,
        myprofileURI: this.myprofileURI,
        translations: this.getTranslationsForMenu(),
      },
    });
    await popover.present();

    popover.onDidDismiss().then(({ data }) => {
      if (data?.isLogout) {
        this.onLogoutClicked();
      }
    });
  }

  private getTranslationsForMenu(): Record<string, string> {
    return ['profile.myProfile', 'profile.logout'].reduce(
      (x, y) => ((x[y] = this.translateService.instant(y)), x),
      {}
    );
  }
}
